module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAA5UlEQVQ4T+3UL0uDQRwH8M8vGGTFKlgEm4pdFNtYMljEYteX4AvwJbi+NBYWTGKcsiyiTVgRrBYxGE6EDR7Gc5uPG0teObg/H77H7+7CnFvM2bN4MLGKFk6Dt2knmpgwsYIetvGIg+B9EpoFEzXcYrcA9FEPPnJoKZhYwjUa+MRyob/BYfBVhubANo7xgA4ucTEc20E7OKkCJrxgD0e4wjm6uMdGKL8huYSv2A8GibMRGDQT67gL1qok3AyefzaMg8OxreDp12BxYRn4p2sz2vQPNmd6y7kqz1SUaYnG5xf/H1ZN+A1aXz4VltihHQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/image/index/shang-index.png
// module id = 6RLR
// module chunks = 1